export const API_SUCCESS = 'S001'
export const API_FAILURE = 'F001'
